import React, { Component } from "react";
import Slider from "react-slick";
import "./Slick.scss";

export default class Slick extends Component {  
  render() {
    const { previews, type, selectedIndex } = this.props
    const settings = {
      className: "slider variable-width",
      dots: false,
      infinite: false,
      slidesToShow: 1,
      swipeToSlide: true,
      variableWidth: true
    }
    return (
      <div className='slick-root'>
        <div className='slick-slider-wrapper'>
          {
            Array.isArray(previews) &&
            <Slider {...settings}>
              {previews.map((url, index) => (
                <div>
                  <img src={url} alt='' style={{ height: '76px', border: (selectedIndex === index ? '4px solid #1fbdcb' : '4px solid #f4f4f4') }} onClick={() => this.props.handleClickThumbnail(type, index)} />
                </div>
              ))}
            </Slider>
          }
        </div>
      </div>
    )
  }
}